<template>
	<div>
		<div class="list-item" v-for="(item, index) in list" :key="index">
			<!--<div class="item-name" @click="tabClick(item.id,item,item.code)" :class="{'tabClass' : skuNumber == item.code}">-->
			<div class="item-name" @click="tabClick(item.id,item,item.code)">
				<i class="iconfont icon-duidiedefangkuai-copy duidieClass"></i> {{item.name}}
			</div>
			<div v-if="item.children" class="children-item">
				<list :list="item.children"></list>
			</div>

		</div>
		<!--弹窗1-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="名称" label-width="20%">
					<el-input type="text" v-model="name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="地址" label-width="20%">
					<el-input type="text" v-model="addr" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="坐标" label-width="20%">
					<el-input type="text" v-model="coordinate" placeholder="经纬度，以逗号分隔" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="面积" label-width="20%">
					<el-input type="text" v-model="area" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="责任人" label-width="20%">
					<el-input type="text" v-model="link_man" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" label-width="20%">
					<el-input type="text" v-model="link_tel" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--弹窗2-->
		<div class="specilDialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth2" :close-on-click-modal="false">
				<el-form>
					<el-form-item label="名称" label-width="20%">
						<el-input type="text" v-model="nameValue" autocomplete="off"></el-input>
						<i class="iconfont icon-xinghao xinghaoClass"></i>
					</el-form-item>
					<el-form-item label="设备型号" label-width="20%">
						<el-input type="text" v-model="model" autocomplete="off"></el-input>
						<i class="iconfont icon-xinghao xinghaoClass"></i>
					</el-form-item>
					<div style="text-align: center;margin: 30px 0;">
						<el-radio v-model="type" label="一般设备">一般设备</el-radio>
						<el-radio v-model="type" label="网关">网关</el-radio>
					</div>
				</el-form>

				<div slot="footer" class="dialog-footer">
					<el-button @click="childSave()" class="confrim" type="primary">立即创建</el-button>
					<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	import $ from 'jquery'
	export default {
		name: "List",
		props: {
			list: Array
		},
		mounted() {
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
					this.dialogWidth2 = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
					this.dialogWidth2 = "70%"
				} else {
					this.dialogWidth = "30%"
					this.dialogWidth2 = "36%"
				}
			})
			$(".item-name").click(function(event) {
				//				var current = $(".item-name");
				//				for(var i = 0; i < current.length; i++) {
				//					current.eq(i).removeClass("tabClass")
				//				}
				//				$(this).addClass("tabClass");
				//				event.stopPropagation()
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
				this.dialogWidth2 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
				this.dialogWidth2 = "70%"
			} else {
				this.dialogWidth = "30%"
				this.dialogWidth2 = "36%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				projectList: [], //
				dialogFormVisible: false,
				dialogFormVisible2: false,
				title: '', //弹窗标题
				/*表单*/
				username: '', //用户名
				password: '', //密码
				tel: '', //手机号
				confirmPassword: '', //确认密码
				passwordValue: '', //密码
				confirmPasswordValue: '', //确认密码
				dialogWidth: '30%', //dialog的宽度
				dialogWidth2: '36%', //dialog的宽度
				editId: null, //编辑的id
				notDo: false, //不执行开关
				listRow: {}, //编辑行数据
				c_id: '', //c_id
				rowList: {}, //c列表
				name: '', //名称
				addr: '', //地址
				coordinate: '', //坐标
				area: '', //面积
				link_man: '', //责任人
				link_tel: '', //联系电话
				latitude: '', //纬度
				longitude: '', //经度
				/*表单2*/
				parent_id: '', //父级id
				nameValue: '', //名称
				model: '', //型号
				type: '一般设备',
				project_id: '', //项目id
				project_idT: '',
				skuNumber: null, //

			}
		},
		methods: {
			//tab的点击
			tabClick(id, list, code) {
				//console.log(document.getElementsByClassName('item-name'))
				$(".item-name").click(function(event) {
					var current = $(".item-name");
					for(var i = 0; i < current.length; i++) {
						current.eq(i).removeClass("tabClass")
					}
					$(this).addClass("tabClass");
					event.stopPropagation()
				})
				this.skuNumber = code
				if(list.type == 1) { //设备
					//TODO
					//					this.$router.push({
					//						path: '/customer/equipment',
					//						name: 'Equipment',
					//						query: {
					//							id: id,
					//							list: JSON.stringify(list),
					//						}
					//					})
					this.$router.push({
						path: '/customer/equipment',
						name: 'Equipment',
						query: {
							id: id
						}
					})
				} else if(list.type == 2) { //网关
					//TODO
					//					this.$router.push({
					//						path: '/customer/gateway',
					//						name: 'Gateway',
					//						query: {
					//							id: id,
					//							list: JSON.stringify(list),
					//						}
					//					})
					this.$router.push({
						path: '/customer/gateway',
						name: 'Gateway',
						query: {
							id: id
						}
					})
				}
			},
			//编辑的点击
			editClick(id, list) {
				//console.log(list)
				this.coordinate = ''
				this.listRow = list
				this.title = "编辑项目"
				this.editId = id
				if(list.parent_id != undefined) { //子项目
					this.dialogFormVisible2 = true
					this.nameValue = list.name
					this.model = list.model
					if(list.type == 1) {
						this.type = '一般设备'
					} else if(list.type == 2) {
						this.type = '网关'
					}

				} else { //父项目
					this.dialogFormVisible = true
					this.name = list.name
					this.addr = list.addr
					this.area = list.area
					this.link_man = list.link_man
					this.link_tel = list.link_tel
					if(list.longitude) {
						this.coordinate = list.latitude + '，' + list.longitude
					}
				}
			},
			//项目的保存
			save() {
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				var c_id = window.sessionStorage.getItem('c_id')
				var index = this.coordinate.lastIndexOf("，");
				this.latitude = this.coordinate.substring(0, index)
				this.longitude = this.coordinate.substring(index + 1, this.coordinate.length)
				var params = {
					id: this.editId,
					c_id: c_id,
					c_manager_id: manager_id,
					src: 2,
					code: this.$uuid.v1(),
					name: this.name,
					addr: this.addr, //地址
					latitude: this.latitude, //纬度
					longitude: this.longitude, //经度
					area: this.area, //面积
					link_man: this.link_man, //责任人
					link_tel: this.link_tel, //联系电话
					status: 1,
					version: 0,
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/project/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.dialogFormVisible = false
						location.reload();
						//this.$parent.getList();
						//this.$emit('fatherMethod');
						//this.emptyList()
					} else {
						this.$message('新增失败！')
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//添加子项目的点击
			addChildClick(id, list) {
				this.project_idT = id
				this.childEditId = id
				if(!list.project_id) {
					this.parent_id = 0
				} else {
					this.parent_id = id
				}
				this.project_id = list.project_id
				this.title = "新建子项目"
				this.dialogFormVisible2 = true
				this.emptyListChild();
			},
			//子项目清空
			emptyListChild() {
				this.nameValue = ''
				this.model = ''
			},
			//子保存
			childSave() {
				var type;
				if(this.type == '一般设备') {
					type = 1
				} else {
					type = 2
				}
				var project_id;
				if(!this.project_id) {
					project_id = this.project_idT
				} else {
					project_id = this.project_id
				}
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				var c_id = window.sessionStorage.getItem('c_id')
				if(this.editId) { //编辑
					var params = {
						id: this.editId,
						src: 2,
						c_id: c_id,
						c_manager_id: manager_id,
						project_id: project_id,
						parent_id: this.parent_id,
						name: this.nameValue,
						model: this.model,
						type: type,
						code: '-' + this.$uuid.v1(),
						status: 1,
						version: 0,
					}
				} else {
					var params = { //添加
						src: 2,
						c_id: c_id,
						c_manager_id: manager_id,
						project_id: project_id,
						parent_id: this.parent_id,
						name: this.nameValue,
						model: this.model,
						type: type,
						code: '-' + this.$uuid.v1(),
						create_time: timestamp,
						status: 1,
						version: 0,
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/subproject/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.dialogFormVisible2 = false
						location.reload();
					} else {
						this.$message('新增失败！')
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//删除
			deleteClick(id, list) {
				var url;
				if(list.parent_id != undefined) { //子项目
					url = '/zkep2/subproject/save'
					var params = {
						id: id,
						status: 0
					}
				} else { //父项目
					url = '/zkep2/project/save'
					var params = {
						id: id,
						code: list.code + '_' + id,
						status: 0
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				this.$confirm('确认删除此项目以及其子项目吗?', '确认要删除吗', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + url, qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {　
							location.reload();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
		},
	};
</script>
<style>
	.item-name {
		position: relative;
		height: 36px;
		line-height: 36px;
		/*width: 100%;*/
		margin-bottom: 6px;
		margin-top: 6px;
		/*border-bottom: 1px solid #ccc;*/
		box-shadow: 0px 2px 8px #999;
		color: #439DFD;
		font-size: 13px;
		cursor: pointer;
		text-indent: 30px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.children-item {
		font-size: 20px!important;
		padding-left: 6%;
		color: #999;
	}
	
	.tabClass {
		background-color: #457ED8;
		color: #fff;
		font-size: 14px;
	}
	
	.IClass {
		font-size: 14px;
	}
	
	.item-name:hover {
		/*background-color: #457ED8;*/
		/*color: #fff;*/
		/*font-size: 14px;*/
	}
	
	.item-name:hover .duidieClass {
		/*font-size: 16px;*/
	}
	
	.duidieClass {
		margin-right: 4px;
		font-size: 16px;
	}
	
	.ellipsisClass {
		display: none;
		position: absolute;
		right: 10px;
		top: -3px;
		font-weight: 600;
		font-size: 17px;
	}
	
	.popBox {
		display: none;
		position: absolute;
		right: -105px;
		top: 0;
		width: 104px;
		height: 120px;
		background-color: #F2F2F2;
		border: 1px solid #ccc;
		color: #000;
		text-indent: 8px;
	}
	
	.popBox label {
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/List.vue